import React, { Component } from "react";

import {
  Form,
  Select,
  Button,
  Input,
  DatePicker,
  Radio,
  Checkbox,
  Row,
  Col,
  Spin,
} from "antd";

import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import NotificationStore from "../store/NotificationStore";

import DriversStore from "../store/DriversStore";
import dayjs from "dayjs";
import EmailMessageStore from "../store/EmailMessageStore";
import CompanyStore from "../store/CompanyStore";
const dateFormat = "DD-MM-YYYY HH:mm";
const currentDateTime = dayjs();
const { Option } = Select;
class NotificationAdd extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      parent: false,
      driver: false,
      user: false,
      companyId: "",
      loadList: 0,
      selectedDriver: [],
      selectAllDrivers: false,
      classId: [],
      selectAllClass: false,
      notification_Id: -1,
      sendNow: false,
      selectAllCompanies: false,
      selectedCompany: [],
      loadingSpin: false,
    };
    this.notificationStore = new NotificationStore();
    this.driverStore = new DriversStore();
    this.emailMsgStore = new EmailMessageStore();
    this.companyStore = new CompanyStore();
  }

  onNotificationDetailsSubmit = async (values) => {
    this.setState({ loading: true });

    const NotificationDetails = {
      ...values,
      postedAt: values.postedAt
        ? values.postedAt.format("DD-MM-YYYY HH:mm")
        : null,
      // postedAt: values?.postedAt?.format("DD-MM-YYYY HH:mm"),
      notification_Id: this.state.notification_Id,
      companyId: this.state.selectedCompany,
      sendNow: this.state.sendNow ? 1 : 0,
    };
    const data = {
      tokenId: "",
      NotificationDetails: NotificationDetails,
    };

    const response = await this.notificationStore.addData(data);
    await this.props.response(response);
    await this.setState({ loading: false });
    // if (response?.success === "S") {
    //   this.notificationStore.getNotificationDetails
    // }
    // if (response?.success === "S") {
    //   message.success(response.message);
    //   this.props.navigate("/notificationlist");
    // } else if (response?.data?.success == "F0") {
    //   response.data.errors.map((value) => {
    //     message.error(value["inventoryNo"]);
    //   });
    // }
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      this.context.viewStateStore.setNotificationStates({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({
        selectedCompany: this.props.getUserData().userCompanyId,
      });

      await this.setState({ isadmin: this.props.getUserData().isadmin });
      await this.notificationStore.toGetDriverName(
        this.props.getUserData().userCompanyId
        //  this.props.getUserData().isadmin
      );
      await this.setState({ loadData: 1 });
    }
    if (this.props.notificationId) {
      this.setState({ loadingSpin: true });
    }

    await this.notificationStore.getCompanies();

    await this.notificationStore.getClassNames();

    await this.setState({ loadList: 1 });

    const Id = this.props.notificationId;

    if (Id) {
      await this.filldata(Id);
      await this.setState({ Id: Id });
      await this.setState({ loadingSpin: false });
    }
  }

  async filldata(Id) {
    const getnotificationData =
      await this.notificationStore.getNotificationDetails(Id);

    await this.setState({
      selectedCompany: getnotificationData.companyId,
      notification_Id: getnotificationData.notification_Id,
    });
    await this.notificationStore.getCompanyDataById(
      getnotificationData.companyId
    );

    await this.notificationStore.getCompanies();

    await this.notificationStore.getClassNames();

    this.formRef.current.setFieldsValue({
      companyId: getnotificationData.companyId,
      notification_Id: getnotificationData.notification_Id,
      postedAt: getnotificationData.postedAt
        ? dayjs(getnotificationData.postedAt, "DD-MM-YYYY HH:mm")
        : null,
      // postedAt:getnotificationData.postedAt,
      notification: getnotificationData.notification,
      sendNow: getnotificationData.sendNow,
      schoolDriver: getnotificationData.schoolDriver,
      classId: getnotificationData.classId,
      driverId: getnotificationData.driverId,
    });

    if (getnotificationData.schoolDriver === "school") {
      this.setState({ parent: true });
      this.setState({ driver: false });
    } else if (getnotificationData.schoolDriver === "driver") {
      this.setState({ driver: true });
      this.setState({ parent: false });
    } else if (getnotificationData.schoolDriver === "user") {
      this.setState({ driver: false });
      this.setState({ parent: false });
    }
  }
  onSelect = (e) => {
    const value = e.target.value;

    if (value === "school") {
      this.setState({ parent: true });
      this.setState({ driver: false });
    } else if (value === "driver") {
      this.setState({ driver: true });
      this.setState({ parent: false });
    } else if (value === "user") {
      this.setState({ driver: false });
      this.setState({ parent: false });
    }
  };

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    if (!this.props.notificationId) {
      this.context.viewStateStore.setNotificationStates({
        companyId: this.state.companyId,
      });
    }

    // await this.formRef.current.setFieldsValue({ companyId: comp.value });
    // await this.setState({ companyId: comp.value });

    await this.notificationStore.toGetDriverName(comp.value);
    await this.handleSearch();
  }

  async handleSearch() {
    await this.notificationStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
      // vehicleId:this.state.selectedDriver
    });
    await this.setState({ loadList: 1 });
  }

  handleSelectAllDrivers = async (e) => {
    if (this.state.selectAllDrivers) {
      const allDrivers = this.notificationStore?.getDriverName.map((val) => {
        return val.driverId;
      });

      this.formRef.current.setFieldsValue({ driverId: allDrivers });
      this.setState({ loadList: 1 });
    } else {
      this.formRef.current.setFieldsValue({ driverId: [] });
    }
    this.setState({ loadList: 1 });
  };

  handleSelectAllClass = async (e) => {
    if (this.state.selectAllClass) {
      const allClass = this.notificationStore?.getClass.map((val) => {
        return val.classId;
      });

      this.formRef.current.setFieldsValue({ classId: allClass });
    } else {
      this.formRef.current.setFieldsValue({ classId: [] });
    }
  };

  handleSelectAllCompanies = async (e) => {
    if (this.state.selectAllCompanies) {
      const allCompanies = this.notificationStore?.allCompanyArray.map(
        (val) => {
          return val.companyId;
        }
      );

      this.formRef.current.setFieldsValue({ companyId: allCompanies });
    } else {
      this.formRef.current.setFieldsValue({ companyId: [] });
    }
  };

  closeModal = () => {
    this.props.closeModal();
  };
  render() {
    return (
      <div style={{ padding: 0, height: "100%" }}>
        <div style={{ paddingBottom: "10px", height: "100%" }}>
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              style={{ maxWidth: "100%", padding: 0 }}
              ref={this.formRef}
              layout="vertical"
              onFinish={this.onNotificationDetailsSubmit}
              // {...this.layout}
              name="nest-message"
              initialValues={{ postedAt: currentDateTime }}
            >
              <Row className="overflowFormInputs">
                <Col span={12} className="formColumnClass">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {(this.props.getUserData().isadmin === -1 ||
                      this.props.getUserData().isadmin === 3) && (
                        <>
                          <Form.Item
                            className="uploadCompany"
                            name="companyId"
                            label={
                              <span>
                                {this.context.translate("_ACCOUNT_")}{" "}
                                <span style={{ color: "red" }}>*</span>
                              </span>
                            }
                            required={false}
                            rules={[
                              {
                                required: true,
                                message: `${this.context.translate(
                                  "_ACCOUNT_"
                                )} ${this.context.translate("_IS_REQUIRED_")}`,
                              },
                            ]}
                            style={{ width: "80%" }}
                          >
                            <Select
                              className="select-dropdown"
                              maxTagCount="responsive"
                              value={this.state.selectedCompany}
                              onChange={async (val) => {
                                if (!this.props.notificationId) {
                                  this.context.viewStateStore.setNotificationStates(
                                    {
                                      companyId: val[0],
                                    }
                                  );
                                }
                                await this.setState({ selectedCompany: val });
                              }}
                              // style={{ width: "514px" }}
                              showSearch
                              onSelect={(val) => {
                                this.notificationStore.toGetDriverName(val);
                              }}
                              mode="multiple"
                              // placeholder="Company"
                              placeholder={this.context.translate("_COMPANY_")}
                              filterOption={(inputValue, option) => {
                                if (option.children) {
                                  return (
                                    option.children
                                      .toLowerCase()
                                      .indexOf(inputValue.toLowerCase()) >= 0
                                  );
                                }
                              }}
                            >
                              {this.notificationStore?.allCompanyArray?.map(
                                (val) => {
                                  return (
                                    <Option value={val.companyId}>
                                      {val.name}
                                    </Option>
                                  );
                                }
                              )}
                            </Select>
                          </Form.Item>
                          <Form.Item className="uploadCompany" label=" ">
                            <Checkbox
                              checked={this.state.selectAllCompanies}
                              // style={{marginLeft:'10px'}}
                              onChange={async (e) => {
                                await this.setState({
                                  selectAllCompanies: e.target.checked,
                                });

                                await this.handleSelectAllCompanies();
                              }}
                            >
                              {this.context.translate("_ALL_")}
                            </Checkbox>
                          </Form.Item>
                        </>
                      )}
                  </div>
                  <div>
                    <Form.Item
                      name="postedAt"
                      // className="uploadCompany"
                      // label={this.context.translate("_POSTED_AT_")}
                      label={
                        <span>
                          {this.context.translate("_POSTED_AT_")}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                      }
                      required={false}
                      rules={[
                        {
                          required: true,
                          message: `${this.context.translate(
                            "_POSTED_AT_"
                          )} ${this.context.translate("_IS_REQUIRED_")}`,
                        },
                      ]}
                    >
                      <DatePicker
                        showTime
                        format={dateFormat}
                        // placeholder="Select date and time"
                        style={{ width: "100%", height: "40px" }}
                      // defaultValue={currentDateTime}
                      />
                    </Form.Item>
                  </div>
                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="notification"
                    className="uploadCompany"
                    //  label={this.context.translate("_NOTIFICATION_")}
                    label={
                      <span>
                        {this.context.translate("_NOTIFICATION_")}{" "}
                        <span style={{ color: "red" }}>*</span>
                      </span>
                    }
                    required={false}
                    rules={[
                      {
                        required: true,
                        message: `${this.context.translate(
                          "_NOTIFICATION_"
                        )} ${this.context.translate("_IS_REQUIRED_")}`,
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    className="uploadCompany"
                    label={
                      <span>
                        {this.context.translate(
                          "_FLEET_COMPANY_COMPANYDETAIL_SELECT_"
                        )}{" "}
                      </span>
                    }
                    name="schoolDriver"
                  >
                    <Radio.Group
                      onChange={(e) => {
                        this.onSelect(e);
                      }}
                    >
                      <Radio value="school">
                        {this.context.translate("_PARENTS_")}
                      </Radio>
                      <Radio value="driver">
                        {this.context.translate("_DRIVER_")}
                      </Radio>
                      <Radio value="user">
                        {this.context.translate(
                          "_FLEET_REPORTS_CHATREPORT_User_"
                        )}
                      </Radio>
                    </Radio.Group>
                  </Form.Item>

                  {this.state.driver && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Form.Item
                        name="driverId"
                        // label="Driver Name"
                        label={this.context.translate(
                          "_FLEET_DASHBORD_VEHICLE_INFORMATION_DRIVERNAME_"
                        )}
                        style={{ width: "80%" }}
                      >
                        <Select
                          className="select-dropdown"
                          // style={{ width: "513px" }}
                          onSearch={this.handleSearch}
                          mode="multiple"
                          maxTagCount={"responsive"}
                          // placeholder="Select Driver"
                          placeholder={this.context.translate(
                            "_SELECT_DRIVER_"
                          )}
                          value={this.state.selectedDriver}
                          showSearch
                          onChange={async (val) => {
                            await this.setState({ selectedDriver: val });
                          }}
                          // fieldNames={{ value: "driverId", label: "name" }}
                          optionFilterProp="children"
                        // options={this.notificationStore?.getDriverName}
                        >
                          {this.notificationStore?.getDriverName?.map((val) => {
                            return (
                              <Select.Option value={Number(val.driverId)}>
                                {val.name}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item label=" ">
                        <Checkbox
                          checked={this.state.selectAllDrivers}
                          onChange={async (e) => {
                            await this.setState({
                              selectAllDrivers: e.target.checked,
                            });

                            await this.handleSelectAllDrivers();
                          }}
                        >
                          {this.context.translate("_ALL_")}
                        </Checkbox>
                      </Form.Item>
                    </div>
                  )}

                  <div style={{ display: this.state.parent ? "" : "none" }}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Form.Item
                        name="classId"
                        // label="Class Name"
                        label={this.context.translate("_CLASS_NAME_")}
                        style={{ width: "80%" }}
                      >
                        <Select
                          className="select-dropdown"
                          mode="multiple"
                          name="classId"
                          maxTagCount={"responsive"}
                          onSearch={this.handleSearch}
                          // placeholder="Select Class"
                          placeholder={this.context.translate("_SELECT_CLASS_")}
                          value={this.state.classId}
                          showSearch
                          onChange={async (val) => {
                            await this.setState({ classId: val });
                          }}
                          // fieldNames={{ value: "classId", label: "className" }}
                          optionFilterProp="children"
                        // options={this.notificationStore?.getClass}
                        >
                          {this.notificationStore?.getClass.map((val) => {
                            return (
                              <Select.Option value={Number(val.classId)}>
                                {val.className}
                              </Select.Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                      <Form.Item label=" ">
                        <Checkbox
                          checked={this.state.selectAllClass}
                          onChange={async (e) => {
                            await this.setState({
                              selectAllClass: e.target.checked,
                            });

                            await this.handleSelectAllClass();
                          }}
                        >
                          {this.context.translate("_ALL_")}
                        </Checkbox>
                      </Form.Item>
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="formFooter">
                <Button
                  className="formsCancelButton"
                  onClick={(e) => {
                    this.closeModal();

                    // this.formRef.current?.resetFields();
                    this.setState({
                      selectAllClass: false,
                      selectAllDrivers: false,
                      selectAllCompanies: false,
                    });
                  }}
                >
                  {this.context.translate(
                    "_FLEET_DASHBORD_ROUTEADD_CANCELBTN_"
                  )}
                </Button>
                <Button
                  htmlType="submit"
                  className="formsSaveButton"
                // onClick={() => this.onExcelSubmit()}
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
                <Button
                  htmlType="submit"
                  className=""
                  onClick={() => this.setState({ sendNow: true })}
                >
                  {this.context.translate("_SEND_NOW_")}
                </Button>
              </div>
            </Form>
          </Spin>
        </div>
      </div>
    );
  }
}

NotificationAdd.contextType = StoreContext;
export default observer(withRouter(NotificationAdd));
